module.exports = "pegasus_template/assets/one-column-text-with-background-preview.png";